<y42-fullscreen-message [header]="'Page not found'" [description]="'Nothing to find here, fellow seeker!'" />
